var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoonOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3541 15.354C18.7173 16.0122 16.9232 16.1748 15.1948 15.8217C13.4663 15.4686 11.8797 14.6153 10.6323 13.3678C9.38484 12.1204 8.53151 10.5338 8.17839 8.80535C7.82527 7.0769 7.98791 5.28277 8.64611 3.646C6.70782 4.42673 5.10148 5.85739 4.10244 7.69272C3.1034 9.52805 2.77391 11.6537 3.17043 13.7054C3.56695 15.757 4.6648 17.6069 6.27577 18.9378C7.88674 20.2687 9.9105 20.9977 12.0001 21C13.797 21.0001 15.5529 20.4624 17.0417 19.4562C18.5304 18.45 19.6841 17.0213 20.3541 15.354Z",
    fill: "#FF9C00",
    stroke: "#FF9C00",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonOutline);
export default __webpack_public_path__ + "static/media/moonOutline.17c504030f432b7f2f7b134391affa63.svg";
export { ForwardRef as ReactComponent };